import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Checkbox, Button} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('userManagementStore')
@observer
class FormModal extends Component {
  state = {
    checked: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {record, title} = this.props
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        shortName: record.shortName,
        // authType: '',
        password: record.password,
        powerUser: this.state.checked,
        phone: record.phone,
        email: record.email
      })
    } else {
      this.formRef.current.setFieldsValue({
        shortName: '',
        authType: '',
        password: '',
        powerUser: this.state.checked
      })
    }
  }

  handleOk = () => {
    const {userManagementStore, handleCancel, record, title} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      if (title === 'edit') {
        userManagementStore.onUpdatePwdBySystem({
         "userId": record.id,
         "password": fieldsValue.password,
         "phone": fieldsValue.phone,
         "email": fieldsValue.email
        }).then(response=> {
          if (response?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        userManagementStore.onChangePageNo()
        userManagementStore.onAddUserAction({
          shortName: fieldsValue.shortName,
          password: fieldsValue.password,
          authType: fieldsValue.authType,
          powerUser: this.state.checked,
          phone: fieldsValue.phone,
          email: fieldsValue.email
        }).then(response=> {
          if (response?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(err => {})
  }
  onChange = e => {
    this.setState({
      checked: e.target.checked,
    })
  }

  render() {
    const {addModalVisible, handleCancel, title, t} = this.props
     //较验邮箱的正则表达式
    const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5\.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
     //较验手机号的正则表达式
    const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
    return (
      <>
        <Modal
          title={title === 'edit' ? `${t(`general.reset`)} ${t(`userManagement.password`)}` : `${t(`general.add`)} ${t(`userManagement.user`)}`}
          closable={true}
          onCancel={handleCancel}
          visible={addModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="shortName" label={t(`userManagement.userName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`userManagement.userName`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} disabled={title === 'edit'}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="password" label={t(`userManagement.password`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`userManagement.password`)} ${t(`general.withoutSpecialChatsPassword`)}`,
                             pattern: new RegExp(/^(?=.*?\d)(?=.*?[a-zA-Z])[a-zA-Z\d!#@*.]{8,16}$/)
                           }]}>
                  <Input.Password placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              {/*<Col xs={24} sm={24} md={24} span={24} >*/}
              {/*  <Form.Item name='authType' label="Login Mode"*/}
              {/*             rules={[{ required: true, message: 'Please enter Login Mode without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>*/}
              {/*    <Select placeholder={t(`general.pleaseEnter`)} allowClear>*/}
              {/*      <Select.Option key='ssofed' value='ssofed'>ssofed</Select.Option>*/}
              {/*    </Select>*/}
              {/*  </Form.Item>*/}
              {/*</Col>*/}
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="phone" label={t(`userManagement.phone`)}
                           rules={[{
                             required: false,
                             message: `${t(`general.pleaseEnter`)} ${t(`general.correctFormat`)}${t(`userManagement.phone`)}`,
                             pattern: new RegExp(regPhone)
                           }]}>
                  <Input maxLength={11} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="email" label={t(`userManagement.email`)}
                           rules={[{
                             required: false,
                             message: `${t(`general.pleaseEnter`)} ${t(`general.correctFormat`)}${t(`userManagement.email`)}`,
                             pattern: new RegExp(regEmail)
                           }]}>
                  <Input placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
              {title === 'edit' ? null : 
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="powerUser" label={t(`userManagement.superAdmin`)}
                           rules={[{
                             required: false,
                             message: `${t(`general.pleaseEnter`)} ${t(`userManagement.superAdmin`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Checkbox checked={this.state.checked} onChange={this.onChange}/>
                </Form.Item>
              </Col>}
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
